import { Breadcrumbs, Button } from "InnoUI/components";
import SC from "./style";
import { useLocation, useNavigate } from "react-router";
import theme from "@theme";
import { apiGet } from "api/callApi";
import { useEffect, useState } from "react";
import Folder from "../FolderTree/Folder";
import NoProject from "./NoProject";
import AddEditFolder from "../AddEditFolder";
import InnoIcons from "InnoUI/innoicons";
import CustomBreadcrumb from "components/CustomBreadcrumb";

const FolderProjectStructure = (props) => {
  const { onClose, rowData, projectType, isManageFolder = false } = props;
  const [folders, setFolders] = useState([]);
  const [openModalView, setOpenModalView] = useState(false);
  const [modalRowData, setModalRowData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isSubFolder, setIsSubFolder] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();

  const breadcrumbItemstype = [
    { label: `${rowData.propertyName || ""}`, href: `/project-home` },
    { label: "General Information" },
  ];

  // function to get Folder Data
  const getFolderData = async () => {
    try {
      const result = await apiGet(
        `/v1/projectfolder/${rowData.id}/${projectType}`,
        false,
      );
      if (result.data) {
        setFolders([...result.data]);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getFolderData();
  }, []);

  // Filter folder types based on the normalized search term (removing spaces)
  const normalizedSearchTerm = searchTerm.replace(/\s+/g, "").toLowerCase();
  const filteredFolderTypes = folders.filter(({ name }) =>
    name.replace(/\s+/g, "").toLowerCase().includes(normalizedSearchTerm),
  );

  const handleEditModal = (data) => {
    setOpenModalView(true);
    if (data) {
      setIsEditing(true);
      setModalRowData(data);
    }
    // if (isManageFolder) {
    //   navigate(0);
    // }
  };
  const handleAddOpenModal = () => {
    setOpenModalView(true);
    setIsEditing(false);
    setIsSubFolder(false);

    setModalRowData(null);
  };

  const handleAddSubFolder = (data) => {
    setOpenModalView(true);
    if (data) {
      setIsEditing(false);
      setModalRowData(data);
      setIsSubFolder(true);
    }
  };

  return (
    <>
      {!isManageFolder ? (
        <SC.DrawerTitlesContainer>
          <SC.DrawerTitles>
            {`Manage Folder Structure for ${rowData?.propertyName || ""}${
              rowData?.propertyName && rowData?.occupantName ? " " : ""
            }${rowData?.occupantName || ""}`}
          </SC.DrawerTitles>

          <SC.CloseIcon>
            <InnoIcons.CloseIcon onClick={onClose} />
          </SC.CloseIcon>
        </SC.DrawerTitlesContainer>
      ) : (
        <>
          {projectType == 0 ? (
            <Breadcrumbs
              items={breadcrumbItemstype}
              separator=">"
              currentPath={currentPath}
            />
          ) : (
            <CustomBreadcrumb />
          )}
        </>
      )}
      <SC.TemplateNameContainer
        style={{ marginTop: isManageFolder ? "50px" : "0px" }}
      >
        <SC.InputContiner>
          <SC.SearchIcon />
          <SC.InputStyle
            placeholder={"Search"}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SC.InputContiner>

        {filteredFolderTypes.length > 0 && (
          <Button
            caption={"+ New Folder"}
            type="submit"
            color="white"
            onClick={handleAddOpenModal}
            fontSize="12px"
            style={{
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "100px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        )}
      </SC.TemplateNameContainer>

      <SC.Container>
        <SC.FolderContainer>
          <SC.FChildren>
            <SC.FolderSpan>{`Folder Structure - ${
              rowData?.projectId
                ? rowData?.templateName
                : rowData?.displayTemplateName || ""
            }`}</SC.FolderSpan>
          </SC.FChildren>
          {filteredFolderTypes.length > 0 ? (
            <SC.FolderStructureContainer>
              {filteredFolderTypes.map((folder) => (
                <Folder
                  key={folder.id}
                  folder={folder}
                  fetchData={getFolderData}
                  handleEditModal={handleEditModal}
                  handleAddSubFolder={handleAddSubFolder}
                  isManageFolder={isManageFolder}
                />
              ))}
            </SC.FolderStructureContainer>
          ) : (
            <NoProject handleAddOpenModal={handleAddOpenModal} />
          )}
        </SC.FolderContainer>
      </SC.Container>

      {openModalView && (
        <AddEditFolder
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          folderData={modalRowData}
          setModalRowData={setModalRowData}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          parentId={modalRowData?.id || null}
          projectId={rowData.id}
          fetchData={getFolderData}
          isSubFolder={isSubFolder}
          projectType={projectType}
          isManageFolder={isManageFolder}
        />
      )}
    </>
  );
};

export default FolderProjectStructure;
